<template>
    <div class="page">
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="用户账号">
                <el-input v-model="queryForm.userName" placeholder="请填写账号" style="width: 180px"></el-input>
            </el-form-item>
            <!--el-form-item label="注册时间">
                <el-date-picker
                    v-model="registerTime"
                    clearable
                    style="width: 180px"
                    type="datetimerange"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item-->


            <el-form-item label="手机号码">
                <el-input v-model="queryForm.userMobile" placeholder="请填写手机号码" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="用户昵称">
                <el-input v-model="queryForm.userNickname" placeholder="请填写用户昵称" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
                <el-input v-model="queryForm.userRealname" placeholder="请填写真实姓名" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="getUserMeansList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>

        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group"></div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>

                    <span title="导出数据" class="icon-box" @click="exportUserMoneyList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span>

                    <span class="icon-box" @click="refreshUserMeansList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                :data="userMeansList"
                height="100%"
                row-key="id"
                size="small"
                @selection-change="handleSelectionChange"
                :default-expand-all="true"
            >
                <el-table-column align="center" prop="user_name" label="账号"> </el-table-column>
                <el-table-column align="center" prop="user_mobile" label="手机号"> </el-table-column>
				<el-table-column align="center" prop="user_nickname" label="昵称"> </el-table-column>
                <!-- 动态生成资产列 -->
                <el-table-column v-for="currency in currencyList" :key="currency.fieldName" 
                    align="center" :prop="currency.fieldName" :label="currency.currencyName">
                </el-table-column>
                <el-table-column align="center" label="状态">
                    <template slot-scope="scop">
                        <el-tag type="success" effect="light" v-if="scop.row.status == 1">正常</el-tag>
                        <el-tag type="danger" effect="light" v-if="scop.row.status == 0">禁用</el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column align="center" prop="user_realname" label="真实姓名"> </el-table-column> -->
                <el-table-column align="center" prop="create_time" label="注册时间"> </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="150" >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="editUserMoney(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">充值/扣款</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>

            <!-- 充值用户 -->
            <el-dialog title="充值/扣除" :visible.sync="showDialog" width="30%" @close="closeDialog">
                <div>
                    <el-form :model="userMeans" ref="userMeansForm" :rules="rules" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="货币类型" prop='type'>
                            <el-select
                                v-model="userMeans.type"
                                placeholder="请选择货币类型"
                                size="small"
                                style="width: 200px"
                            ><el-option :label="item.value" :value="item.key" v-for='(item,index) in enumList' :key='index'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="充值金额" prop="money">
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="userMeans.money"
                                :disabled="userMeansState == 'check'"
                                placeholder="请输入金额"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="userMeansState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, get, post } from '@/utils/request.js';
import { mapState } from 'vuex';
import { list } from 'postcss';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetUserMeansList();
                this.getUserMeansList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetUserMeansList();
                this.getUserMeansList();
                this.$emit('resetCheckState');
            }
        },
        "userInfo.isSa":{
            handler(val,old){
                if(val != old){
                    this.isSa = val;
                }
            },
            immediate:true
        }
    },
    computed:{
        ...mapState(['userInfo']),
    },
    data() {
        return {
            dialogVisible: false,
            balanceUserName: '',
            balance: '',
            queryForm: {
                userName: '',
                startTime: '',
                endTime: '',
                userMobile: '',
                userNickname: '',
                userRealname: ''
            },
            registerTime: [], //注册时间
            enumList:[],//货币类型
            loading: false,
            showDialog: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            userMeansState: 'add',
            multipleSelection: [],
            userMeansList: [],
            isSearch: false,
            userMeans: {
                userId: '',
                type: '', //币种名称
                money: '' //资金
            },
            btnLoading: false,
            currencyList: [],//

            rules: {
                type: [{ required: true, message: '货币类型不能为空', trigger: 'blur' }],
                money: [{ required: true, message: '金额为空', trigger: 'blur' }]
            },
            isSa: ''
        };
    },
    created() {
        this.getUserMeansList();
        this.getMoneyClass();
    },
    methods: {
        Moneydispose(obj,name){
            return
        },
        //获取货币类型
        getMoneyClass(){
            get('/mpp/utils/getEnum',{enumType:'currency_type'}).then((res)=>{
                if(res.success && res.code == 200){
                    this.enumList = res .enumList
					//this.enumList.shift()
                }else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
                console.log('console.log(res);',this.enumList);
            })
        },
        //用户充值
        editUserMoney(id) {
            // if (type == 1) {
            //     this.userMeansState = 'add';
            // } else {
                this.userMeansState = 'balance';
            // }

            this.showDialog = true;
            this.userMeans.userId = id;
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        getBalance(row) {
            get('/zxchain/chainapi/getUserInfo', { address: row.walletAddress }).then((res) => {
                this.balanceUserName = '';
                this.balance = '';
                this.dialogVisible = true;
                this.balanceUserName = row.userName;
                this.balance = res.userInfo.Balance;
            });
        },
        resetUserMeansList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.userMeansList = [];
        },
        resetDialog() {
            this.userMeansState = 'add';
            this.showDialog = false;
            this.registerTime = [];
            this.queryForm = {
                userName: '', //用户名称
                startTime: '',
                endTime: '',
                userMobile: '',
                userNickname: '',
                userRealname: ''
            };
            this.getUserMeansList();
        },
        closeDialog() {
            this.userMeans = {};
            this.showDialog = false;
            this.$refs.userMeansForm.resetFields();
        },
        submitForm() {
            if (this.userMeansState == 'add') {
                console.log('this.userMeans', this.userMeans);
                this.$refs.userMeansForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        console.log(this.userMeans);
                        get(`/mpp/moneyrecord/amountOperation`, { ...this.userMeans }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetUserMeansList();
                                this.closeDialog();
                                this.getUserMeansList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                                this.closeDialog();
                            }
                        });
                    }
                });
            }
            if (this.userMeansState == 'balance') {
                console.log('this.userMeans', this.userMeans);
                this.$refs.userMeansForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        console.log(this.userMeans);
                        get(`/mpp/moneyrecord/amountOperation`, { ...this.userMeans }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetUserMeansList();
                                this.closeDialog();
                                this.getUserMeansList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                                this.closeDialog();
                            }
                        });
                    }
                });
            }
        },

        checkUserMeans(userId) {
            this.currentUserId = userId;
            this.getMppLessonById();
            this.showDialog = true;
            this.userMeansState = 'check';
        },

        refreshUserMeansList() {
            this.resetUserMeansList();
            this.getUserMeansList();
        },

        getUserMeansList() {
            this.loading = true;
            if (this.registerTime) {
                this.queryForm.startTime = this.registerTime[0];
                this.queryForm.endTime = this.registerTime[1];
            }
            console.log(this.queryForm);
            get(`/mpp/user/findMoneysList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.currencyList = res.currencyList;
                    this.userMeansList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        // 原setCurrencyList方法已被动态列替代
        getMppLessonById() {
            get(`/mpp/user/get`, { id: this.currentUserId }).then((res) => {
                if (res.success) {
                    this.userMeans = { ...this.userMeans, ...res.mppUser };
                }
            });
        },
        /**
         * 导出用户资金信息
         */
        exportUserMoneyList() {
            this.btnLoading = true;
            exprotExcel(`/finance/user/export`, { ...this.queryForm  });
        },

        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getUserMeansList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getUserMeansList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.userMeans-table-expand {
    font-size: 0;
    margin-top: -20px;
}
.userMeans-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.userMeans-table-expand .el-form-item {
    margin-left: 10%;
    margin-bottom: -1.5%;
    width: 100%;
}
.sum {
    font-size: 14px;
    color: #606266;
}
::v-deep .el-table{
    /* 移除pre-line设置，因为现在资产以单独列显示 */
}
</style>
